import { useMemo } from "react";
import { DeliveryChannel } from "@Front/Api/Auth/Customer/Auth";

type Args = {
	deliveryChannel: DeliveryChannel;
	maskedEmail?: string;
	email: string;
	partialPhoneNumber: string;
	smsTitlePrefix: string;
	emailTitlePrefix: string;
};

export function useStepTotpDeliveryMessage(args: Args): string {
	const { deliveryChannel, maskedEmail, email, partialPhoneNumber, smsTitlePrefix, emailTitlePrefix } = args;

	return useMemo((): string => {
		if (deliveryChannel === "email") {
			const emailTarget = maskedEmail && maskedEmail.length > 0 ? maskedEmail : email;
			return emailTarget ? `${emailTitlePrefix} ${emailTarget}` : emailTitlePrefix;
		}

		const formattedPhone = partialPhoneNumber ? partialPhoneNumber.replace(/(.{2})/g, "$1 ").trim() : "";
		return formattedPhone.length > 0 ? `${smsTitlePrefix} ${formattedPhone}` : smsTitlePrefix;
	}, [deliveryChannel, maskedEmail, email, partialPhoneNumber, emailTitlePrefix, smsTitlePrefix]);
}
